module.exports = __webpack_public_path__ + "media/images/card_background-592f20486069664b77f33d15b5cf0901.png";